import React from "react";
import Sidebar from "../components/organisms/layout/SideBar";

const Layout = ({ children }) => {
	return (
		<div className="flex h-screen">
			<Sidebar />
			<div className="flex-grow flex flex-col pt-10 md:pt-0">
				<main className="h-screen p-6 bg-white overflow-auto">{children}</main>
			</div>
		</div>
	);
};

export default Layout;